import React, { useState } from "react";
import AddAchModal from "./addAchModal";
import { cx } from "../../Util/classHelpers";
import LoadingSpinner from "../CommonComponents/loadingSpinner";
import { useFetchAchQuery, useDeleteAchMutation } from "../../Apis/achApi";
import { useFetchPaymentSourcesQuery } from "../../Apis/paymentSourceApi";

const getAchText = (count) => {
  if (count === 0) {
    return "No ACH bank information found";
  } else if (count === 1) {
    return "1 bank account added";
  } else {
    return `${count} bank accounts added`;
  }
}

const AchInfoSection = () => {
  const [showModal, setShowModal] = useState(false);
  const { data: achData, isLoading } = useFetchAchQuery();
  const { data: paymentSources } = useFetchPaymentSourcesQuery();
  const [deleteAch] = useDeleteAchMutation();
  
  const handleAddAch = () => {
    setShowModal(true);
  };

  const handleRemoveAch = async (id) => {
    try {
      await deleteAch(id).unwrap();
    } catch (error) {
      console.error("Failed to delete ACH:", error);
    }
  };

  const banks = achData?.getBanks() || [];
  const showLoading = isLoading;

  return (
    <div className={cx("mt-2 paymentMethod position-relative", showLoading && "disabled-div")}>
      <div className="container-fluid sd-shadow">
        <div
          className="row mt-3 mx-5 align-items-center credit-card-info-holder"
          style={{ minHeight: 48 }}
        >
          <div className="col-4 text-start fw-bold">ACH Bank Account</div>
          <div className="col-4 fw-light" style={{ color: "#888" }}>
            <span className="sub-text">{getAchText(banks.length)}</span>
          </div>
          <div className="col-4 text-end">
            {banks.length === 0 && (
              <span
                type="button"
                className="text-btn text-btn-update"
                onClick={handleAddAch}
              >
                Add Bank Account
              </span>
            )}
          </div>
        </div>
        <div className="mb-3 mx-5">
          {banks.map((bank, idx) => {
            const companies = paymentSources?.getCompaniesWithUsBankAccount(bank.getId()) ?? [];
            const isDisabled = !bank.isEnabled();
            return (
              <React.Fragment key={bank.getId() || idx}>
                <hr className="my-2 text-muted" />
                <div
                  className="row align-items-center p-2"
                  style={{ minHeight: 48, color: isDisabled ? "#dc3545" : "inherit" }}
                >
                  <div className="col-3" style={{ wordWrap: "break-word", overflowWrap: "break-word" }}>
                    <span>{bank.getBankName()}</span>
                  </div>
                  <div className="col-2">
                    Ending in <span className="fw-bold">{bank.getLast4()}</span>
                  </div>
                  <div className="col-2">
                    Routing: <span className="fw-bold">{bank.getRoutingNumber()}</span>
                  </div>
                  <div className="col-3 text-end">
                    Assigned to{" "}
                    <span className="fw-bold">{companies.length}</span>{" "}
                    {companies.length === 1 ? "business" : "businesses"}
                  </div>
                  <div className="col-2 text-end">
                    <span
                      type={companies.length > 0 ? "span" : "button"}
                      className={cx(companies.length > 0 ? "text-muted" : "text-btn")}
                      disabled={companies.length > 0}
                      onClick={companies.length > 0 ? null : () => handleRemoveAch(bank.getId())}
                    >
                      Remove
                    </span>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
        <AddAchModal
          show={showModal}
          onClose={() => setShowModal(false)}
        />
      </div>
      {showLoading && <LoadingSpinner />}
    </div>
  );
};

export default AchInfoSection;

